import React, { useRef, useState, useEffect } from 'react'
import styles from './MyPointsInfo.module.css'
import classNames from 'classnames'
import { Menu, Modal, ConfigProvider, Divider } from 'antd'
import PointsDetail from './PointsDetail'
import RechargeRecord from './RechargeRecord'
import RechargeMyPoints from './RechargeMyPoints/RechargeMyPoints'
import Cookies from 'js-cookie';
export default function MyPointsInfo(props) {
  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, [props.openStatus]) // 空数组意味着这个 effect 只会在组件挂载时执行一
  const [current, setCurrent] = useState(sessionStorage.getItem('rechargeCurrent') || '0')
  const menuList = [
    {
      key: '0',
      label: '积分详情',
    },
    {
      key: '1',
      label: '积分充值',
    },
    {
      key: '2',
      label: '充值记录',
    },
  ]
  const menuList1 = [{
    key: '0',
    label: '积分详情',
  }]
  const changeMenuMethod = (e) => {
    setCurrent(e.key)
    sessionStorage.setItem('rechargeCurrent', e.key)
  }
  return (
    <Modal
      open={props.openStatus}
      // onOk={handleOk}
      onCancel={(e) => {
        props.onCancel()
      }}
      // width={'70%'}
      width={'1070px'}
      title={null}
      footer={null}
    >
      <div className={styles.Modal}>
        <div style={{ width: '200px', height: '100%' }}>
          <img
            src={require('../../../assert/logo_name_icon.png')}
            alt=""
            style={{ width: '180px', marginTop: '0px' }}
          />
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#f5b544',
              },
            }}
          >
            <Menu
              defaultSelectedKeys={0}
              mode="inline"
              items={menuList}
              onClick={changeMenuMethod}
              selectedKeys={current}
              inlineCollapsed={false}
            />
          </ConfigProvider>
        </div>

        <div
          type="vertical"
          style={{
            position: 'absolute',
            top: -20,
            bottom: -20,
            left: 198,
            width: 1,
            background: 'rgba(0,0,0,0.1)',
            margin: 'auto',
          }}
        ></div>
        {current === '0' && (
          <PointsDetail
          />
        )}
        {current === '1' && (
          <RechargeMyPoints
            onCancel={props.onCancel}
          />
        )}
        {current === '2' && (
          <RechargeRecord
          />
        )}
      </div>
    </Modal>
  )
}

